var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{key:_vm.title,attrs:{"to":{
    name: 'shop',
    query: {
      groups: _vm.groups.concat( [_vm.groupId]),
    },
  },"exact":""}},[(_vm.image)?_c('v-list-item-avatar',{attrs:{"tile":"","size":"80"}},[_c('v-img',{attrs:{"lazy-src":_vm.$config.managerMedia + 'picturepool/' + _vm.image,"src":_vm.$config.managerMedia + 'picturepool/' + _vm.image}})],1):_vm._e(),_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('v-list-item-subtitle',{domProps:{"innerHTML":_vm._s(_vm.description)}})],1),_c('v-list-item-action',[_c('v-icon',[_vm._v("mdi-chevron-right")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }